import { render } from "./ActiveTemplate.vue?vue&type=template&id=6a848ab8&scoped=true"
import script from "./ActiveTemplate.vue?vue&type=script&lang=js"
export * from "./ActiveTemplate.vue?vue&type=script&lang=js"

import "./ActiveTemplate.vue?vue&type=style&index=0&id=6a848ab8&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a848ab8"]])

export default __exports__